// 20.02.26 - Page shown to suspended users when they try to log in
import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const AccountSuspendedPage = () => {
  const { logout } = useAuth();

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f8fafc',
      padding: '24px'
    }}>
      <div style={{
        maxWidth: '480px',
        width: '100%',
        background: 'white',
        borderRadius: '16px',
        padding: '48px 32px',
        textAlign: 'center',
        boxShadow: '0 4px 16px rgba(0,0,0,0.08)'
      }}>
        {/* 20.02.26 - COOC logo area */}
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>⏸️</div>
        
        <h1 style={{ 
          color: '#1e293b', 
          fontSize: '24px', 
          fontWeight: '700',
          marginBottom: '16px' 
        }}>
          Your Account is On Hold
        </h1>
        
        <p style={{ 
          color: '#64748b', 
          fontSize: '16px', 
          lineHeight: '1.6',
          marginBottom: '32px' 
        }}>
          Your COOC account has been temporarily placed on hold. 
          Your documents and data are safe and have not been deleted.
        </p>

        <div style={{
          background: '#f1f5f9',
          borderRadius: '12px',
          padding: '24px',
          marginBottom: '32px',
          textAlign: 'left'
        }}>
          <p style={{ 
            fontWeight: '600', 
            color: '#1e293b',
            marginBottom: '12px',
            fontSize: '15px'
          }}>
            To restore your account, please contact COOC:
          </p>
          <p style={{ color: '#475569', marginBottom: '8px', fontSize: '15px' }}>
            📧 <a href="mailto:support@cooc.com.au" style={{ color: '#0891b2' }}>
              support@cooc.com.au
            </a>
          </p>
          <p style={{ color: '#475569', fontSize: '15px' }}>
            🌐 <a href="https://cooc.com.au" style={{ color: '#0891b2' }}>
              cooc.com.au
            </a>
          </p>
        </div>

        <button
          onClick={logout}
          style={{
            background: '#1e293b',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            padding: '12px 32px',
            fontSize: '15px',
            fontWeight: '600',
            cursor: 'pointer'
          }}
        >
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default AccountSuspendedPage;

